import { Stack } from "@mui/material";
import { Datagrid } from "./datagrid/Datagrid";
import { useMediaGrid } from "./hooks/useMediaGrid";
import { useModal } from "./hooks/useModal";
import { Modal } from "./Modal";
import { Review } from "./Review";
import { Toolbar } from "./toolbar/Toolbar";
import type { MediaGridProps } from "./types";

export function MediaManagementPage() {
	const mediaGrid = useMediaGrid();
	const { modalState, openModal, closeModal } = useModal();
	const props: MediaGridProps = {
		...mediaGrid,
		openModal,
	};

	return (
		<Stack height="100%">
			<Review />
			<Toolbar
				setSearchText={mediaGrid.setSearchText}
				mediaGrid={mediaGrid}
				openModal={openModal}
			/>
			<Datagrid {...props} />
			<Modal modalState={modalState} closeModal={closeModal} />
		</Stack>
	);
}
